import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { utilsApps } from 'src/app/helpers/utils-app';
import { ConfirmationDialog } from 'src/app/modules/dialogs/ConfirmationDialog';
import { AuthService } from 'src/app/Service/auth.service';
import { CaeUserService } from 'src/app/Service/cae-user-service.service';
import { EventService } from 'src/app/Service/event.service';

@Component({
  selector: 'app-upload-cae-users',
  templateUrl: './upload-cae-users.component.html',
  styleUrls: ['./upload-cae-users.component.css']
})
export class UploadCaeUsersComponent implements OnInit {
  _folderZip: File;

  _templateUsers: File;
  currentUser: any;
  /** For controller the confirms dialogs */
  public confirmationDialog: ConfirmationDialog = new ConfirmationDialog();
  public isConfirmationDialog: boolean = false;

  constructor(private _modalService: NgbModal,
    private readonly _service: CaeUserService,
    private readonly translate: TranslateService,
    private readonly authService: AuthService,
    protected eventService: EventService,
  ) {

    this.authService.currentUser.subscribe(resp => {
      if (resp === null || resp.username === undefined)
        this.currentUser = null;
      else
        this.currentUser = resp;
    });
  }


  ngOnInit(): void {
    this.getDataLanguage();
  }


  private getDataLanguage() {
    this.translate.stream('common.confirmDialog.messageCancel').subscribe((res: string) => {
      this.msg_confirmDialog = res;
    });
    this.translate.stream('common.confirmDialog.messageTwoCancel').subscribe((res: string) => {
      this.msgTwo_confirmDialog = res;
    });
  }

  files: any[] = [];

  /**
   * on file drop handler
   */
  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;

      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 0.5);
      }
    }, 1);

  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      console.log(item);
      let extension = item.name.split('.').pop();

      item.progress = 0;
      //Validar el tamaño y tipo de archivo
      if (item.size < 2000000) {
        if ((item.type == "application/x-zip-compressed" || extension == "rar") && this.files.length <= 10) {
          this.files.push(item);
        }
      }
      else {
        if (item.type == "application/x-zip-compressed" || extension == "rar") {
          this.eventService.errorMessage(3, "cae-user.catMsg.FILE_TOO_BIG");
        }
      }
    }
    this.uploadFilesSimulator(0);
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  ////////////////////////////


  onClearData() {

  }


  /**
 * For actions of by confirms dialogs, to do the correct process
 * @param $event For know the action to do
 */
  protected orchestratorCloseDialog($event: any): void {
    if (this.confirmationDialog.keyConfirmDialog === "confirmExitCreateCAEUser") {
      this.onClose($event);
    }
    this.isConfirmationDialog = false;
    this.confirmationDialog = new ConfirmationDialog();
  }

  /** For use translate */
  protected msg_confirmDialog: string = "";
  protected msgTwo_confirmDialog: string = "";
  /**
* For actions of by confirms dialogs, to do the correct process
* @param $event For know the action to do
*/
  protected onClose(action: number): void {
    /** For active confirm dialog */
    if (action === 0) {
      this.confirmationDialog.keyConfirmDialog = "confirmExitCreateCAEUser";
      this.confirmationDialog.message = this.msg_confirmDialog;
      this.confirmationDialog.messageTwo = this.msgTwo_confirmDialog;
      this.isConfirmationDialog = true;
    }
    /** For confirm action of confirm dialog */
    if (action === 1) {
      this.onClearData();
      this._modalService.dismissAll();
    }
  }

  //Para el zip
  onFileSelected(event: Event): void {

    const input = event.target as HTMLInputElement;
    if (input?.files?.length) {
      const file = input.files[0];
      if (file.type == "application/x-zip-compressed" || file.name.split('.').pop() == "zip" || file.name.split('.').pop() == "rar") {
        //100 MB
        if (file.size <= 104857600) {
          this._folderZip = file;
        }
        else {
          this.eventService.errorMessage(3, "cae-user.catMsg.FILE_TOO_BIG");
        }
      }
      else
        this.eventService.errorMessage(3, "cae-user.catMsg.FILE_ZIP");


    }
  }


  onFileSelectedTemplate(event: Event): void {

    const input = event.target as HTMLInputElement;
    if (input?.files?.length) {
      const file = input.files[0];

      console.log(file);
      if (file.type == "text/csv" || file.name.split('.').pop() == "csv") {
        if (file.size <= 2000000) {
          this._templateUsers = file;
        }
        else {
          this.eventService.errorMessage(3, "cae-user.catMsg.FILE_TOO_BIG");
        }
      }
      else
        this.eventService.errorMessage(3, "cae-user.catMsg.FILE_CSV");

    }
  }


  onDownload() {
    this.eventService.startLoadingData();
    try {

      this._service.GetFileTemplate("").subscribe({
        next: res => {
          console.log(res);
          let result = res.body;

          if (res.status == 200) {
            if (result.code == "SUCCESS") {
              let _fileName = "template_upload_user";
              let _utils = new utilsApps();
              let content = result.content;
              _utils.downloadFileFromB64(content, _fileName, '.csv');
            }
            else {
              this.eventService.errorMessage();
            }
          }
          this.eventService.completeLoadingData();
        },
        error: error => {
          console.log(error);
          this.eventService.errorMessage(1);
          this.eventService.completeLoadingData();
        }
      });

    } catch (error) {
      console.log(error);
      this.eventService.completeLoadingData();
    }
  }

  onSave() {

    this.eventService.startLoadingData();

    console.log(this._templateUsers);
    console.log(this._folderZip);

    try {
      //Validar que el zip no sea nulo
      //Validar que el template no sea nulo

      if (this._templateUsers == null || this._templateUsers == undefined) {
        this.eventService.errorMessage(3, "Adjunte el archivo con los registros de usuarios");
        this.eventService.completeLoadingData();
        return;
      }

      if (this._folderZip == null || this._folderZip == undefined) {
        this.eventService.errorMessage(3, "Adjunte el archivo con los registros de usuarios");
        this.eventService.completeLoadingData();
        return;
      }

      // Crear un objeto FormData para enviar archivos
      const formData = new FormData();
      // // Agregar los archivos al FormData
      formData.append('file', this._templateUsers);

      formData.append('zip', this._folderZip);


      const file = formData.get('file');
      console.log('Archivo en formData:', file);

      this._service.BulkUsers(formData).subscribe({
        next: res => {
          console.log("res=> ", res);
          let result = res.body;

          if (res.ok) {

            if (result.code == "SUCCESS") {
              this.eventService.successMessage(0, "cae-user.catMsg.BULK_SUCCESS");
              this.onClose(1);

              //recargar pantalla
              setTimeout(() => {
                window.location.reload();
              }, 3000);

            }
            else if (result.code == "INVALID_PARAM") {
              let content = result.content;
              console.log("content", content);

              const cleanAditionalInfo = content?.replace(/['"]/g, '') || '';

              console.log("cleanAditionalInfo", cleanAditionalInfo);

              this.eventService.errorMessage(3, "cae-user.catMsg.INVALID_PARAM",
                cleanAditionalInfo ?
                  "cae-user.catMsg." + cleanAditionalInfo : '');

            } else if (result.code == "NOT_FOUND") {
              this.eventService.errorMessage(3, "cae-user.catMsg.NOT_FOUND");
            }
            else if (result.code == "file-processing") {
              this.eventService.errorMessage(3, "cae-user.catMsg.FILE_PROCESSING");
            }
            else {
              console.log(result);
              this.eventService.errorMessage(3, "common.catMessage.errorRequest");
            }

          }
          else {

            this.translate.stream('common.error500').subscribe((res: string) => {
              this.eventService.errorMessage(0, res);
            });

          }

          this.eventService.completeLoadingData();
        },
        error: error => {
          console.log(error);
          this.eventService.completeLoadingData();
          this.eventService.errorMessage(1);
        }
      });


    } catch (error) {
      console.log(error);
    }
  }

}
